export class ProjectRapport {
    public adresse: string | null = null;
    public ville: string | null = null;
    public province: string | null = null;
    public telephone: string | null = null;
    public budget: number | null = null;
    public presentation: string | null = null;
    public finance: string | null = null;
    public terrain: string | null = null;
}